import { render, staticRenderFns } from "./OftaDialog.vue?vue&type=template&id=6dd25799&"
import script from "./OftaDialog.vue?vue&type=script&lang=js&"
export * from "./OftaDialog.vue?vue&type=script&lang=js&"
import style0 from "./OftaDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports